// import React, { useMemo } from "react";
// import FleetrifyDumButton from "../../components/Button";
// import FleetrifyCard from "../../components/Card";
// import DashboardLayout from "../../components/DashboardLayout";
// import { optionIcon } from "../../components/pages/Dashboard/items";
// import DriverOverviewDetails from "../../components/pages/Dashboard/Companies";
// import DashboardSubscriptionTable from "../../components/Table/DashboardSubTable";
// import { CustomBarChart } from "../../components/pages/Dashboard/Chart/BarChart";
// import { useDashboardControllers } from "../../controllers/useDashboardControllers";
// import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";
// import { DashboardFleetSummaryCard } from "../../components/pages/Dashboard/Cards/summary";
// import { fleetrifyIcons } from "../../assets/icons/icons";
// import FleetrifyDashMap from "../../components/pages/Dashboard/Map/fleetMap";
// import { useGetDashboardQuery } from "../../redux/services/clienDashboardApi";
// import { DashboardSummarySkeleton } from "../../components/pages/Dashboard/DashboardSummarySkeleton";
// import { skipToken } from "@reduxjs/toolkit/query";

// const Dashboard = () => {
//   const {
//     navigate,
//     hasMounted,
//     showCompanyCard,
//     toggleCompanyCard,
//     dateRange,
//     handleDateRangeChange,
//   } = useDashboardControllers();

//   // -----------------------------
//   // 1. Load location
//   // -----------------------------
//   const [coords, setCoords] = React.useState<{
//     lat: number;
//     lng: number;
//   } | null>(null);

//   React.useEffect(() => {
//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         setCoords({
//           lat: pos.coords.latitude,
//           lng: pos.coords.longitude,
//         });
//       },
//       () => {
//         console.warn("Location denied");
//         setCoords({ lat: 0, lng: 0 });
//       }
//     );
//   }, []);

//   // -----------------------------
//   // 2. API call (hook ALWAYS runs)
//   // -----------------------------
//   const { data, isLoading, isError } = useGetDashboardQuery(
//     coords ? { lat: coords.lat, lng: coords.lng } : skipToken
//   );

//   const { cards, graphData, table } = data || {};


//   // -----------------------------
//   // 6. Transform graph data
//   // -----------------------------
//   const overviewData = useMemo(() => {
//     if (!graphData?.labels || !graphData?.datasets) return [];

//     const mainBranch = graphData.datasets.find((d: any) =>
//       d.label.toLowerCase().includes("main")
//     );
//     const annexBranch = graphData.datasets.find((d: any) =>
//       d.label.toLowerCase().includes("annex")
//     );

//     return graphData.labels.map((label: string, index: number) => ({
//       name: label,
//       mainBranch: mainBranch?.data[index] ?? 0,
//       annexBranch: annexBranch?.data[index] ?? 0,
//     }));
//   }, [graphData]);


//   // -----------------------------
//   // 3. Pre-API skeleton (coords still loading)
//   // -----------------------------
//   if (!coords) {
//     return (
//       <DashboardLayout
//         title="Dashboard"
//         description="Get a clear, actionable view of your staff and operations."
//         showDateRange={true}
//       >
//         <main className="mt-10 space-y-10">
//           <DashboardSummarySkeleton />
//         </main>
//       </DashboardLayout>
//     );
//   }

//   // -----------------------------
//   // 4. Loading (coords ready, API running)
//   // -----------------------------
//   if (isLoading) {
//     return (
//       <DashboardLayout
//         title="Dashboard"
//         description="Get a clear, actionable view of your staff and operations."
//         showDateRange={true}
//       >
//         <main className="mt-10 space-y-10">
//           <DashboardSummarySkeleton />
//         </main>
//       </DashboardLayout>
//     );
//   }

//   // -----------------------------
//   // 5. Error UI
//   // -----------------------------
//   if (isError) {
//     return (
//       <DashboardLayout
//         title="Dashboard"
//         description="Get a clear, actionable view of your staff and operations."
//         showDateRange={true}
//       >
//         <div className="flex items-center justify-center h-[60vh] px-4">
//           <div className="bg-white shadow-md rounded-lg p-8 text-center max-w-sm w-full">
//             <div className="flex justify-center mb-4">
//               <div className="h-12 w-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center text-2xl">
//                 !
//               </div>
//             </div>

//             <h2 className="text-lg font-semibold text-gray-800">
//               Something Went Wrong
//             </h2>

//             <p className="text-sm text-gray-500 mt-2">
//               We couldn’t load your dashboard data. Please try again.
//             </p>

//             <button
//               onClick={() => window.location.reload()}
//               className="mt-5 bg-[#143887] text-white px-4 py-2 rounded-md text-sm"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </DashboardLayout>
//     );
//   }

//   // -----------------------------
//   // 7. Final UI
//   // -----------------------------
//   return (
//     <DashboardLayout
//       title="Dashboard"
//       description="Get a clear, actionable view of your staff and operations in one place."
//       containerClass="pb-10"
//       dateRange={dateRange}
//       onDateRangeChange={handleDateRangeChange}
//       showDateRange={true}
//       onDataRefresh={() => console.log("Data refreshed")}
//     >
//       <main className="mt-10 space-y-10">
//         {/* SUMMARY */}
//         <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
//           <h3 className="text-sm font-semibold text-[#00032A] mb-4">Summary</h3>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//             <DashboardFleetSummaryCard
//               // title="Total Vehicle"
//               title="Total Branches"
//               value={cards?.total_vehicles}
//               changeText="2% from previous month"
//               changeDirection="up"
//               icon={fleetrifyIcons.vehicleLogo}
//             />

//             <DashboardFleetSummaryCard
//               // title="Active Trips"
//               title="Total Users"
//               value={cards?.active_trips}
//               changeText="4% from last quarter"
//               changeDirection="down"
//               // icon={fleetrifyIcons.activeTipLogo}
//                 icon={fleetrifyIcons.dutyIcon}
//             />

//             <DashboardFleetSummaryCard
//               title="Pending Requests"
//               value={cards?.pending_requests}
//               changeText="8% Up from last quarter"
//               changeDirection="up"
//               icon={fleetrifyIcons.requestIcon}
//             />

//             <DashboardFleetSummaryCard
//               title="Drivers on duty"
//               value={cards?.drivers_on_duty}
//               changeText="8% Up from last quarter"
//               changeDirection="up"
//               icon={fleetrifyIcons.dutyIcon}
//             />
//           </div>
//         </section>

//         {/* MAP + CHART */}
//         <section className="flex flex-col lg:flex-row gap-4 w-full h-full">
//           <div className="flex-[2] h-[300px] lg:h-auto">
//             <FleetrifyCard>
//               <div className="flex justify-between items-center pb-5">
//                 <div>
//                   <h3 className="text-lg font-semibold  text-[#00032A]">
//                     Real-time Fleet Map
//                   </h3>
//                   <p className="text-xs text-[#4F4F4F] italic">Live Status</p>
//                 </div>
//                 <FleetrifyDumButton label="Track Fleet" onClick={() => { }} />
//               </div>
//               <FleetrifyDashMap />
//             </FleetrifyCard>
//           </div>

//           <div className="flex-1">
//             <FleetrifyCard cardContainerClass="space-y-5 h-full">
//               <div className="flex justify-between items-center pb-5">
//                 <div>
//                   <h3 className="text-lg font-semibold text-[#00032A]">
//                     Fleet Activity Chart
//                   </h3>
//                   <p className="text-xs text-[#4F4F4F] italic">(in millions)</p>
//                 </div>
//                 <button>{optionIcon}</button>
//               </div>
//               <CustomBarChart data={overviewData} />
//             </FleetrifyCard>
//           </div>
//         </section>

//         {/* TABLE + OVERVIEW */}
//         <section className="flex flex-col lg:flex-row gap-4 w-full relative">
//           <div className="flex-[2]">
//             <FleetrifyCard cardContainerClass="!p-0">
//               <div className="flex px-6 py-4 justify-between items-center sticky top-0 bg-white">
//                 <h3 className="text-lg font-semibold text-[#00032A]">
//                   Recent Trips
//                 </h3>
//                 <button>{optionIcon}</button>
//               </div>

//               <div className="overflow-y-scroll h-[500px] hide-scrollbar">
//                 <DashboardSubscriptionTable />
//               </div>
//             </FleetrifyCard>
//           </div>

//           <div className="absolute right-0 -top-8">
//             <button
//               className="text-xs text-[#143887] font-bold"
//               onClick={toggleCompanyCard}
//             >
//               {showCompanyCard
//                 ? "Hide Drivers Overview"
//                 : "Display Drivers Overview"}
//             </button>
//           </div>

//           {hasMounted && showCompanyCard && (
//             <DriverOverviewDetails
//               show={true}
//               drivers={table}
//               onNavigateCompany={() => navigate(FLEETRIFYROUTEPATH.COMPANY)}
//             />
//           )}
//         </section>
//       </main>
//     </DashboardLayout>
//   );
// };

// export default Dashboard;


// OLDER VERSION (BEFORE RECENT EDITS)

// import React, { useMemo } from "react";
// import FleetrifyDumButton from "../../components/Button";
// import FleetrifyCard from "../../components/Card";
// import DashboardLayout from "../../components/DashboardLayout";
// import { optionIcon } from "../../components/pages/Dashboard/items";
// import DriverOverviewDetails from "../../components/pages/Dashboard/Companies";
// import DashboardSubscriptionTable from "../../components/Table/DashboardSubTable";
// import { CustomBarChart } from "../../components/pages/Dashboard/Chart/BarChart";
// import { useDashboardControllers } from "../../controllers/useDashboardControllers";
// import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";
// import { DashboardFleetSummaryCard } from "../../components/pages/Dashboard/Cards/summary";
// import { fleetrifyIcons } from "../../assets/icons/icons";
// import FleetrifyDashMap from "../../components/pages/Dashboard/Map/fleetMap";
// import {
//   useGetDashboardQuery,
//   useGetRecentOrdersQuery,
// } from "../../redux/services/clienDashboardApi";
// import { DashboardSummarySkeleton } from "../../components/pages/Dashboard/DashboardSummarySkeleton";
// import { skipToken } from "@reduxjs/toolkit/query";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "sonner";
// import { selectUser } from "../../redux/slices/authSlice";
// import { useSelector } from "react-redux";
// import { useGetCurrentUserQuery } from "../../redux/services/authApi";

// const Dashboard = () => {
//   const {
//     navigate,
//     hasMounted,
//     showCompanyCard,
//     toggleCompanyCard,
//     dateRange,
//     handleDateRangeChange,
//   } = useDashboardControllers();

//   const location = useLocation();
//   const navigateTo = useNavigate();
//   const user = useSelector(selectUser);
//   const { data: currentUser } = useGetCurrentUserQuery();
//   const showActivityTracking = user?.company?.latestSubscription_plan?.name;

//   React.useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const payment = params.get("payment");
//     const type = params.get("type") ?? "unknown";

//     if (payment === "success") {
//       if (type === "renewal") {
//         toast.success("Subscription renewed successfully! Your plan is now active.");
//       } else if (type === "upgrade") {
//         toast.success("Plan upgraded successfully! Enjoy your new features.");
//       } else {
//         toast.success("Payment successful!");
//       }
//       navigateTo("/dashboard", { replace: true });
//     } else if (payment === "failed") {
//       toast.error("Payment was not completed. Please try again.");
//       navigateTo("/dashboard", { replace: true });
//     }
//   }, [location.search, navigateTo]);

//   const [coords, setCoords] = React.useState<{
//     lat: number;
//     lng: number;
//   } | null>(null);

//   React.useEffect(() => {
//     navigator.geolocation.getCurrentPosition(
//       (pos) => {
//         setCoords({
//           lat: pos.coords.latitude,
//           lng: pos.coords.longitude,
//         });
//       },
//       () => {
//         console.warn("Location denied");
//         setCoords({ lat: 0, lng: 0 });
//       }
//     );
//   }, []);

//   const { data, isLoading, isError } = useGetDashboardQuery(
//     coords ? { lat: coords.lat, lng: coords.lng } : skipToken
//   );

//   const {
//     data: recentOrdersData,
//     isLoading: ordersLoading,
//   } = useGetRecentOrdersQuery({ perPage: 10, sortBy: "desc" });

//   const recentOrders = recentOrdersData?.data ?? [];

//   const { cards, graphData, table } = data || {};

//   const overviewData = useMemo(() => {
//     if (!graphData?.labels || !graphData?.datasets) return [];

//     const mainBranch = graphData.datasets.find((d: any) =>
//       d.label.toLowerCase().includes("main")
//     );
//     const annexBranch = graphData.datasets.find((d: any) =>
//       d.label.toLowerCase().includes("annex")
//     );

//     return graphData.labels.map((label: string, index: number) => ({
//       name: label,
//       mainBranch: mainBranch?.data[index] ?? 0,
//       annexBranch: annexBranch?.data[index] ?? 0,
//     }));
//   }, [graphData]);

//   if (!coords) {
//     return (
//       <DashboardLayout
//         title="Dashboard"
//         description="Get a clear, actionable view of your staff and operations."
//         showDateRange={true}
//       >
//         <main className="mt-10 space-y-10">
//           <DashboardSummarySkeleton />
//         </main>
//       </DashboardLayout>
//     );
//   }


//   if (isLoading) {
//     return (
//       <DashboardLayout
//         title="Dashboard"
//         description="Get a clear, actionable view of your staff and operations."
//         showDateRange={true}
//       >
//         <main className="mt-10 space-y-10">
//           <DashboardSummarySkeleton />
//         </main>
//       </DashboardLayout>
//     );
//   }

//   if (isError) {
//     return (
//       <DashboardLayout
//         title="Dashboard"
//         description="Get a clear, actionable view of your staff and operations."
//         showDateRange={true}
//       >
//         <div className="flex items-center justify-center h-[60vh] px-4">
//           <div className="bg-white shadow-md rounded-lg p-8 text-center max-w-sm w-full">
//             <div className="flex justify-center mb-4">
//               <div className="h-12 w-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center text-2xl">
//                 !
//               </div>
//             </div>
//             <h2 className="text-lg font-semibold text-gray-800">
//               Something Went Wrong
//             </h2>
//             <p className="text-sm text-gray-500 mt-2">
//               We couldn't load your dashboard data. Please try again.
//             </p>
//             <button
//               onClick={() => window.location.reload()}
//               className="mt-5 bg-[#143887] text-white px-4 py-2 rounded-md text-sm"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </DashboardLayout>
//     );
//   }

//   return (
//     <DashboardLayout
//       title="Dashboard"
//       description="Get a clear, actionable view of your staff and operations in one place."
//       containerClass="pb-10"
//       dateRange={dateRange}
//       onDateRangeChange={handleDateRangeChange}
//       showDateRange={true}
//       onDataRefresh={() => console.log("Data refreshed")}
//     >
//       <main className="mt-10 space-y-10">
//         {/* SUMMARY */}
//         <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
//           <h3 className="text-sm font-semibold text-[#00032A] mb-4">Summary</h3>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//             <DashboardFleetSummaryCard
//               title="Total Branches"
//               value={cards?.total_branches}
//               changeText="2% from previous month"
//               changeDirection="up"
//               icon={fleetrifyIcons.vehicleLogo}
//             />
//             <DashboardFleetSummaryCard
//               title="Total Users"
//               value={cards?.total_users}
//               changeText="4% from last quarter"
//               changeDirection="down"
//               icon={fleetrifyIcons.dutyIcon}
//             />
//             <DashboardFleetSummaryCard
//               title="Pending Requests"
//               value={cards?.pending_requests}
//               changeText="8% Up from last quarter"
//               changeDirection="up"
//               icon={fleetrifyIcons.requestIcon}
//             />
//             <DashboardFleetSummaryCard
//               title="Total Drivers"
//               value={cards?.drivers_on_duty}
//               changeText="8% Up from last quarter"
//               changeDirection="up"
//               icon={fleetrifyIcons.dutyIcon}
//             />
//           </div>
//         </section>

//         {/* MAP + CHART */}
//         {showActivityTracking !== "Individual Starter" && (
//           <section className="flex flex-col lg:flex-row gap-4 w-full h-full">
//             <div className="flex-[2] h-[300px] lg:h-auto">
//               <FleetrifyCard>
//                 <div className="flex justify-between items-center pb-5">
//                   <div>
//                     <h3 className="text-lg font-semibold text-[#00032A]">
//                       Real-time Fleet Map
//                     </h3>
//                     <p className="text-xs text-[#4F4F4F] italic">Live Status</p>
//                   </div>
//                   <FleetrifyDumButton label="Track Fleet" onClick={() => { }} />
//                 </div>
//                 <FleetrifyDashMap />
//               </FleetrifyCard>
//             </div>

//             <div className="flex-1">
//               <FleetrifyCard cardContainerClass="space-y-5 h-full">
//                 <div className="flex justify-between items-center pb-5">
//                   <div>
//                     <h3 className="text-lg font-semibold text-[#00032A]">
//                       Fleet Activity Chart
//                     </h3>
//                     <p className="text-xs text-[#4F4F4F] italic">(in millions)</p>
//                   </div>
//                   <button>{optionIcon}</button>
//                 </div>
//                 <CustomBarChart data={overviewData} />
//               </FleetrifyCard>
//             </div>
//           </section>
//         )}

//         {/* TABLE + OVERVIEW */}
//         <section className="flex flex-col lg:flex-row gap-4 w-full relative">
//           <div className="flex-[2]">
//             <FleetrifyCard cardContainerClass="!p-0">
//               <div className="flex px-6 py-4 justify-between items-center sticky top-0 bg-white">
//                 <h3 className="text-lg font-semibold text-[#00032A]">
//                   Recent Orders
//                 </h3>
//                 <button>{optionIcon}</button>
//               </div>
//               <div className="overflow-y-scroll h-[500px] hide-scrollbar">
//                 <DashboardSubscriptionTable
//                   orders={recentOrders}
//                   isLoading={ordersLoading}
//                 />
//               </div>
//             </FleetrifyCard>
//           </div>

//           <div className="absolute right-0 -top-8">
//             <button
//               className="text-xs text-[#143887] font-bold"
//               onClick={toggleCompanyCard}
//             >
//               {showCompanyCard
//                 ? "Hide Drivers Overview"
//                 : "Display Drivers Overview"}
//             </button>
//           </div>

//           {hasMounted && showCompanyCard && (
//             <DriverOverviewDetails
//               show={true}
//               drivers={table}
//               onNavigateCompany={() => navigate(FLEETRIFYROUTEPATH.COMPANY)}
//             />
//           )}
//         </section>
//       </main>
//     </DashboardLayout>
//   );
// };

// export default Dashboard;

import React, { useMemo, useState } from "react";
import FleetrifyDumButton from "../../components/Button";
import FleetrifyCard from "../../components/Card";
import DashboardLayout from "../../components/DashboardLayout";
import { optionIcon } from "../../components/pages/Dashboard/items";
import DriverOverviewDetails from "../../components/pages/Dashboard/Companies";
import DashboardSubscriptionTable from "../../components/Table/DashboardSubTable";
import { CustomBarChart } from "../../components/pages/Dashboard/Chart/BarChart";
import { useDashboardControllers } from "../../controllers/useDashboardControllers";
import { FLEETRIFYROUTEPATH } from "../../routes/routesPath";
import { DashboardFleetSummaryCard } from "../../components/pages/Dashboard/Cards/summary";
import { fleetrifyIcons } from "../../assets/icons/icons";
import FleetrifyDashMap from "../../components/pages/Dashboard/Map/fleetMap";
import {
  useGetDashboardQuery,
  useGetRecentOrdersQuery,
  useGetOnboardingChecklistQuery,
  ChecklistItem,
} from "../../redux/services/clienDashboardApi";
import { DashboardSummarySkeleton } from "../../components/pages/Dashboard/DashboardSummarySkeleton";
import { skipToken } from "@reduxjs/toolkit/query";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { selectUser } from "../../redux/slices/authSlice";
import { useSelector } from "react-redux";
import { useGetCurrentUserQuery } from "../../redux/services/authApi";
import { CheckCircle, Circle, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { getTimeGreeting, getTimeOfDay } from "../../utils/greeting";
import { usePaymentVerification } from "../../hooks/usePaymentVerification";


interface OnboardingStep {
  key: string;
  label: string;
  description: string;
  route: string;
  completed: boolean;
}

interface OnboardingProgressProps {
  steps: OnboardingStep[];
  onNavigate: (route: string) => void;
  onDismiss: () => void;
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  steps,
  onNavigate,
  onDismiss,
}) => {
  const completedCount = steps.filter((s) => s.completed).length;
  const progressPercent = Math.round((completedCount / steps.length) * 100);
  const allDone = completedCount === steps.length;

  if (allDone) return null;

  return (
    <section className="bg-white border border-[#e4ebf8] rounded-xl p-6 shadow-sm relative">

      {/* Dismiss button */}
      <button
        onClick={onDismiss}
        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        title="Dismiss (will reappear on next login)"
      >
        <X size={16} />
      </button>

      {/* Header */}
      <div className="flex items-center justify-between mb-1 pr-6">
        <div>
          <h3 className="text-sm font-semibold text-[#00032A]">
            Complete Your Setup
          </h3>
          <p className="text-xs text-gray-400 mt-0.5">
            {completedCount} of {steps.length} steps completed
          </p>
        </div>
        <span className="text-xs font-bold text-[#143887]">
          {progressPercent}%
        </span>
      </div>

      {/* Progress bar */}
      <div className="w-full bg-gray-100 rounded-full h-2 mb-6">
        <div
          className="bg-[#143887] h-2 rounded-full transition-all duration-500"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      {/* Steps */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-0 sm:gap-0 relative">
        {steps.map((step, index) => {
          const isLast = index === steps.length - 1;
          const isNextUp =
            !step.completed &&
            steps.slice(0, index).every((s) => s.completed);

          return (
            <React.Fragment key={step.key}>
              <div className="flex sm:flex-col items-center sm:items-center gap-3 sm:gap-2 flex-1 min-w-0">
                {/* Icon */}
                <div className="flex-shrink-0">
                  {step.completed ? (
                    <CheckCircle
                      size={28}
                      className="text-[#143887]"
                      strokeWidth={2}
                    />
                  ) : (
                    <Circle
                      size={28}
                      className={isNextUp ? "text-[#143887]" : "text-gray-300"}
                      strokeWidth={2}
                    />
                  )}
                </div>

                {/* Label + action */}
                <div className="flex flex-col sm:items-center text-left sm:text-center min-w-0">
                  <span
                    className={`text-xs font-semibold truncate ${
                      step.completed
                        ? "text-[#143887]"
                        : isNextUp
                        ? "text-[#00032A]"
                        : "text-gray-400"
                    }`}
                  >
                    {step.label}
                  </span>
                  <span className="text-[11px] text-gray-400 hidden sm:block">
                    {step.description}
                  </span>
                  {!step.completed && isNextUp && (
                    <button
                      onClick={() => onNavigate(step.route)}
                      className="mt-1 text-[11px] text-white bg-[#143887] hover:bg-[#0e2b63] px-2 py-0.5 rounded-full transition-colors"
                    >
                      Start →
                    </button>
                  )}
                  {step.completed && (
                    <span className="mt-1 text-[11px] text-green-600 font-medium">
                      Done ✓
                    </span>
                  )}
                </div>
              </div>

              {/* Connector line */}
              {!isLast && (
                <div
                  className={`hidden sm:block h-[2px] flex-1 mx-1 rounded-full transition-all duration-500 ${
                    step.completed ? "bg-[#143887]" : "bg-gray-200"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Dismiss hint */}
      <p className="text-[10px] text-gray-300 text-right mt-4">
        {/* Dismissed checklists reappear on next login */}
      </p>
    </section>
  );
};


const Dashboard = () => {
  const {
    navigate,
    hasMounted,
    showCompanyCard,
    toggleCompanyCard,
    dateRange,
    handleDateRangeChange,
  } = useDashboardControllers();

  const location = useLocation();
  const navigateTo = useNavigate();
  const user = useSelector(selectUser);
  const { data: currentUser } = useGetCurrentUserQuery();
  const showActivityTracking = user?.company?.latestSubscription_plan?.name;

  const [checklistDismissed, setChecklistDismissed] = useState(false);

  // RoutePay returns here with ?reference=... after a renewal or upgrade.
  usePaymentVerification();

  const dashboardTaglines = [
    { text: "Here's your business overview", emoji: "📊" },
    { text: "Let's keep things running smoothly", emoji: "⚙️" },
    { text: "Here's what's happening with your fleet today", emoji: "🚚" },
    { text: "Let's get the business moving", emoji: "🚀" },
  ];
  const [taglineIndex, setTaglineIndex] = useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setTaglineIndex((prev) => (prev + 1) % dashboardTaglines.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [dashboardTaglines.length]);

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const payment = params.get("payment");
    const type = params.get("type") ?? "unknown";

    if (payment === "success") {
      if (type === "renewal") {
        toast.success("Subscription renewed successfully! Your plan is now active.");
      } else if (type === "upgrade") {
        toast.success("Plan upgraded successfully! Enjoy your new features.");
      } else {
        toast.success("Payment successful!");
      }
      navigateTo("/dashboard", { replace: true });
    } else if (payment === "failed") {
      toast.error("Payment was not completed. Please try again.");
      navigateTo("/dashboard", { replace: true });
    }
  }, [location.search, navigateTo]);

  const [coords, setCoords] = React.useState<{
    lat: number;
    lng: number;
  } | null>(null);

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setCoords({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      () => {
        console.warn("Location denied");
        setCoords({ lat: 0, lng: 0 });
      }
    );
  }, []);

  const { data, isLoading, isError } = useGetDashboardQuery(
    coords ? { lat: coords.lat, lng: coords.lng } : skipToken
  );

  const {
    data: recentOrdersData,
    isLoading: ordersLoading,
  } = useGetRecentOrdersQuery({ perPage: 10, sortBy: "desc" });

  const {
    data: checklistData,
    isLoading: checklistLoading,
  } = useGetOnboardingChecklistQuery(undefined, {
    // Steps are completed on other pages, so re-check whenever the dashboard opens.
    refetchOnMountOrArgChange: true,
  });

  const recentOrders = recentOrdersData?.data ?? [];
  const { cards, graphData, table } = data || {};

  const onboardingSteps: OnboardingStep[] = useMemo(() => {
    const checklist = checklistData?.data?.checklist ?? [];

    const routeMap: Record<string, string> = {
          //  branch:  FLEETRIFYROUTEPATH.BRANCH  ?? "/branches",
      service: FLEETRIFYROUTEPATH.SERVICES         ?? "/services",
      fleet:   FLEETRIFYROUTEPATH.FLEET_MANAGEMENT ?? "/fleet",
      wallet:  FLEETRIFYROUTEPATH.WALLET           ?? "/wallet/setup",
    };

    const descriptionMap: Record<string, string> = {
        // branch:  "Add your first branch",
      service: "Set up your services",
      fleet:   "Add your vehicles",
      wallet:  "Link your bank account",
    };

    return checklist.map((item: ChecklistItem) => ({
      key:         item.key,
      label:       item.label,
      description: descriptionMap[item.key] ?? "",
      route:       routeMap[item.key]       ?? "/dashboard",
      completed:   item.completed,
    }));
  }, [checklistData]);

  const allDone = checklistData?.data?.all_done ?? false;

  const showChecklist =
    !checklistLoading &&
    !allDone &&
    !checklistDismissed &&
    onboardingSteps.length > 0;

  const overviewData = useMemo(() => {
    if (!graphData?.labels || !graphData?.datasets) return [];

    const mainBranch = graphData.datasets.find((d: any) =>
      d.label.toLowerCase().includes("main")
    );
    const annexBranch = graphData.datasets.find((d: any) =>
      d.label.toLowerCase().includes("annex")
    );

    return graphData.labels.map((label: string, index: number) => ({
      name:        label,
      mainBranch:  mainBranch?.data[index]  ?? 0,
      annexBranch: annexBranch?.data[index] ?? 0,
    }));
  }, [graphData]);

  if (!coords) {
    return (
      <DashboardLayout
        title="Dashboard"
        description="Get a clear, actionable view of your staff and operations."
        showDateRange={true}
      >
        <main className="mt-10 space-y-10">
          <DashboardSummarySkeleton />
        </main>
      </DashboardLayout>
    );
  }

  if (isLoading) {
    return (
      <DashboardLayout
        title="Dashboard"
        description="Get a clear, actionable view of your staff and operations."
        showDateRange={true}
      >
        <main className="mt-10 space-y-10">
          <DashboardSummarySkeleton />
        </main>
      </DashboardLayout>
    );
  }

  if (isError) {
    return (
      <DashboardLayout
        title="Dashboard"
        description="Get a clear, actionable view of your staff and operations."
        showDateRange={true}
      >
        <div className="flex items-center justify-center h-[60vh] px-4">
          <div className="bg-white shadow-md rounded-lg p-8 text-center max-w-sm w-full">
            <div className="flex justify-center mb-4">
              <div className="h-12 w-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center text-2xl">
                !
              </div>
            </div>
            <h2 className="text-lg font-semibold text-gray-800">
              Something Went Wrong
            </h2>
            <p className="text-sm text-gray-500 mt-2">
              We couldn't load your dashboard data. Please try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-5 bg-[#143887] text-white px-4 py-2 rounded-md text-sm"
            >
              Retry
            </button>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout
      title="Dashboard"
      description="Get a clear, actionable view of your staff and operations in one place."
      containerClass="pb-10"
      dateRange={dateRange}
      onDateRangeChange={handleDateRangeChange}
      showDateRange={true}
      onDataRefresh={() => console.log("Data refreshed")}
    >
      <main className="mt-10 space-y-10">

        {/* GREETING */}
        <div>
          <h2 className="text-xl font-bold text-[#143887] flex items-center gap-2">
            {getTimeGreeting()}, {user?.name || "there"}
            {getTimeOfDay() === "night" ? (
              <motion.span
                className="inline-block"
                animate={{ y: [0, -3, 0], opacity: [1, 0.7, 1] }}
                transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
              >
                🌙
              </motion.span>
            ) : (
              <motion.span
                className="inline-block"
                animate={{ rotate: [0, 20, -20, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
              >
                ☀️
              </motion.span>
            )}
          </h2>
          <p className="text-sm text-gray-500 mt-1 flex items-center gap-1 min-h-[20px]">
            <AnimatePresence mode="wait">
              <motion.span
                key={taglineIndex}
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -5 }}
                transition={{ duration: 0.4 }}
                className="flex items-center gap-1"
              >
                {dashboardTaglines[taglineIndex].text}
                <motion.span
                  className="inline-block"
                  animate={{ x: [0, 5, 0] }}
                  transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
                >
                  {dashboardTaglines[taglineIndex].emoji}
                </motion.span>
              </motion.span>
            </AnimatePresence>
          </p>
        </div>

        {/* ONBOARDING PROGRESS */}
        {showChecklist && (
          <OnboardingProgress
            steps={onboardingSteps}
            onNavigate={(route) => navigateTo(route)}
            onDismiss={() => setChecklistDismissed(true)}
          />
        )}

        {/* SUMMARY */}
        <section className="bg-[#E7E9EE] p-4 rounded-lg">
          <h3 className="text-sm font-semibold text-[#00032A] mb-4">Summary</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <DashboardFleetSummaryCard
              title="Total Branches"
              value={cards?.total_branches}
              changeText="2% from previous month"
              changeDirection="up"
              icon={fleetrifyIcons.vehicleLogo}
            />
            <DashboardFleetSummaryCard
              title="Total Users"
              value={cards?.total_users}
              changeText="4% from last quarter"
              changeDirection="down"
              icon={fleetrifyIcons.dutyIcon}
            />
            <DashboardFleetSummaryCard
              title="Pending Requests"
              value={cards?.pending_requests}
              changeText="8% Up from last quarter"
              changeDirection="up"
              icon={fleetrifyIcons.requestIcon}
            />
            <DashboardFleetSummaryCard
              title="Total Drivers"
              value={cards?.drivers_on_duty}
              changeText="8% Up from last quarter"
              changeDirection="up"
              icon={fleetrifyIcons.dutyIcon}
            />
          </div>
        </section>

        {/* MAP + CHART */}
        {showActivityTracking !== "Individual Starter" && (
          <section className="flex flex-col lg:flex-row gap-4 w-full h-full">
            <div className="flex-[2] h-[300px] lg:h-auto">
              <FleetrifyCard>
                <div className="flex justify-between items-center pb-5">
                  <div>
                    <h3 className="text-lg font-semibold text-[#00032A]">
                      Real-time Fleet Map
                    </h3>
                    <p className="text-xs text-[#4F4F4F] italic">Live Status</p>
                  </div>
                  <FleetrifyDumButton label="Track Fleet" onClick={() => {}} />
                </div>
                <FleetrifyDashMap />
              </FleetrifyCard>
            </div>

            {/* <div className="flex-1">
              <FleetrifyCard cardContainerClass="space-y-5 h-full">
                <div className="flex justify-between items-center pb-5">
                  <div>
                    <h3 className="text-lg font-semibold text-[#00032A]">
                      Fleet Activity Chart
                    </h3>
                    <p className="text-xs text-[#4F4F4F] italic">(in millions)</p>
                  </div>
                  <button>{optionIcon}</button>
                </div>
                <CustomBarChart data={overviewData} />
              </FleetrifyCard>
            </div> */}
          </section>
        )}

        {/* TABLE + OVERVIEW */}
        <section className="flex flex-col lg:flex-row gap-4 w-full relative">
          <div className="flex-[2]">
            <FleetrifyCard cardContainerClass="!p-0">
              <div className="flex px-6 py-4 justify-between items-center sticky top-0 bg-white">
                <h3 className="text-lg font-semibold text-[#00032A]">
                  Recent Orders
                </h3>
                <button>{optionIcon}</button>
              </div>
              <div className="overflow-y-scroll h-[500px] hide-scrollbar">
                <DashboardSubscriptionTable
                  orders={recentOrders}
                  isLoading={ordersLoading}
                />
              </div>
            </FleetrifyCard>
          </div>

          <div className="absolute right-0 -top-8">
            <button
              className="text-xs text-[#143887] font-bold"
              onClick={toggleCompanyCard}
            >
              {showCompanyCard
                ? "Hide Drivers Overview"
                : "Display Drivers Overview"}
            </button>
          </div>

          {hasMounted && showCompanyCard && (
            <DriverOverviewDetails
              show={true}
              drivers={table}
              onNavigateCompany={() => navigate(FLEETRIFYROUTEPATH.COMPANY)}
            />
          )}
        </section>
      </main>
    </DashboardLayout>
  );
};

export default Dashboard;